import { Toast } from 'vant';
import api from 'apis';
import apis from '../service/modules/index';
import refundworkapi from '../service/modules/refund';
import apig from '../service/modules/guide';
import { reject } from 'lodash';

/**
 * 跳转投诉首页
 */
export const handleToComplaint = () => {
  // openWindow(
  //   '投诉',
  //   complainlimitState.complaintLeader
  //     ? '/complaint/leader'
  //     : '/complaint/worker'
  // )
  window.yyn.invokeJSB(
    'openWindow',
    {
      openUrl: `https://${
        process.env.NODE_ENV === 'production' ? '' : 't-'
      }complain.ybsjyyn.com/tio/app/#/complain/home`,
      isFullScreen: 1,
      setTitle: '投诉',
      needLoading: 1
    },
    (cb) => {
      console.log('openWindow callback');
    }
  );
};

function getSystemInfo() {
  let systemInfo = {};
  if (
    window.location.href.indexOf('t-tio') !== -1 ||
    window.location.href.indexOf('localhost') !== -1
  ) {
    systemInfo.host = 'https://t-tio.ybsjyyn.com/';
  } else {
    systemInfo.host = 'https://gov.ybsjyyn.com/';
  }
  return systemInfo;
}

/**
 * 通用openWindow 用于拦截历史代码，通用跳转新的投诉首页
 * @param {*} title
 * @param {*} path
 * @param {*} isFullScreen
 * @param {*} needLoading
 * @returns
 */
export const openWindow = (title, path, isFullScreen, needLoading) => {
  if (!path) {
    return;
  }
  Toast.loading({
    message: '跳转中...',
    forbidClick: true
  });
  if (['/complaint/leader', '/complaint/worker'].includes(path)) {
    // 跳转新版投诉
    console.log('---handleToComplaint---');
    handleToComplaint();
    return;
  }
  if (path && path.includes('yyngov:')) {
    window.yyn.invokeJSB(
      'openWindow',
      {
        openUrl: path,
        isFullScreen: 0,
        ...(title ? { setTitle: title } : {}),
        needLoading: 1
      },
      (cb) => {
        console.log(cb, 'callback');
      }
    );
    return;
  }
  window.yyn.invokeJSB(
    'openWindow',
    {
      openUrl: getSystemInfo().host + 'web/#' + path,
      isFullScreen: isFullScreen || 0,
      ...(title ? { setTitle: title } : {}),
      needLoading: needLoading || 1
    },
    (cb) => {
      console.log(cb, 'callback');
    }
  );
};

/**
 * 跳转投诉列表
 * @param {*} type
 * @param {*} param1.itemType  类型
 * @param {*} param1.cityId    区域
 * @param {*} param1.title     标题
 * @param {*} param1.code      紧急程度
 * @returns
 */
export const handleToComplainList = (
  type,
  { itemType, cityId, title, code, isToday }
) => {
  let link = 'yyngov://complaint?path=complaint_inbox_list';
  let params = `${itemType ? `&status=${itemType || ''}` : ''}${
    cityId ? `&cityId=${cityId}` : ''
  }${code ? `&code=${code}` : ''}${isToday ? `&isToday=${isToday}` : ''}`;
  // let params = `${itemType ? `&nature=${itemType || ''}` : ''}${cityId ? `&cityId=${cityId}` : ''}${code ? `&code=${code}` : ''}`
  if (params) {
    link = `yyngov://complaint?path=complaint_inbox_list${params}`;
  }
  if (!link) {
    return;
  }
  Toast.loading({
    message: '跳转中...',
    forbidClick: true
  });
  window.yyn.invokeJSB(
    'openWindow',
    {
      openUrl: link,
      isFullScreen: 0,
      setTitle: title,
      needLoading: 1
    },
    (cb) => {
      console.log(cb, 'callback 跳转投诉列表', link);
    }
  );
};
/**
 * 跳转待办列表 - 业务人员
 * @param {*} type
 * @param {*} param1
 * @returns
 */
export const handleToDoList = ({ type, title }) => {
  let link = `yyngov://complaint?path=pending_list&type=${type}`;
  Toast.loading({
    message: '跳转中...',
    forbidClick: true
  });
  window.yyn.invokeJSB(
    'openWindow',
    {
      openUrl: link,
      isFullScreen: 0,
      setTitle: title,
      needLoading: 1
    },
    (cb) => {
      console.log(cb, 'callback 业务人员', link);
    }
  );
};

/**
 * 跳转详情
 * @param {*} param0
 */
export const handleToComplainDetail = ({
  isSupervise,
  title,
  id,
  mainComplainNumber,
  complainNumber,
  subId,
  superviseNumber
}) => {
  Toast.loading({
    message: '跳转中...',
    forbidClick: true
  });
  let link = '';
  if (isSupervise) {
    // 通过superviseNumber这个字段判断是否是督办，是督办的有值，不是督办的返回是null
    link = `yyngov://complaint?path=supervisor_detail&id=${superviseNumber}&showLinkedTripTicket=true`;
  } else {
    link = `yyngov://complaint?path=complain_detail_container&mainComplainNumber=${mainComplainNumber}&complainNumber=${complainNumber}&subID=${subId}`;
  }
  console.log('====handleToComplainDetail====', link);

  window.yyn.invokeJSB(
    'openWindow',
    {
      openUrl: link,
      isFullScreen: 0,
      setTitle: title,
      needLoading: 1
    },
    (cb) => {
      console.log(cb, 'handleToComplainDetail callback');
    }
  );
};

export const storageGetByName = (type, params) => {
  switch (type) {
    case 'integrityInfo': {
      let integrityInfo = localStorage.getItem('integrityInfo');
      return new Promise((resolve, reject) => {
        if (!integrityInfo) {
          // 获取诚信权限
          apis.getIntegrityLimits().then((res) => {
            if (res.ret === 0) {
              localStorage.setItem('integrityInfo', JSON.stringify(res.data));
              resolve(res.data);
            }
          });
        } else {
          resolve(JSON.parse(integrityInfo));
        }
      });
    }
    case 'auth': {
      let auth = localStorage.getItem('auth');
      return new Promise((resolve, reject) => {
        if (!auth) {
          api.getUnionAuth({}).then((res) => {
            if (res.ret === 0) {
              localStorage.setItem(
                'auth',
                JSON.stringify((res.data.SCENIC_MANAGE_PLATFORM || [])[0] || '')
              );
              localStorage.setItem(
                'level',
                res.data &&
                  res.data.TOURI_INDUSTRY_MANAGE &&
                  res.data.TOURI_INDUSTRY_MANAGE[0].areaLevel
              ) || '';
              resolve((res.data.SCENIC_MANAGE_PLATFORM || [])[0]);
            }
          });
        } else {
          resolve(JSON.parse(auth));
        }
      });
    }
    case 'configList': {
      let configList = localStorage.getItem('configList');
      return new Promise((resolve, reject) => {
        if (!configList) {
          refundworkapi.typePicker().then((res) => {
            if (res.ret === 0) {
              localStorage.setItem('configList', JSON.stringify(res.data));
              resolve(res.data);
            }
          });
        } else {
          resolve(JSON.parse(configList));
        }
      });
    }
    case 'guideInfoObj': {
      let guideInfoObj = localStorage.getItem('guideInfoObj');
      return new Promise((resolve, reject) => {
        if (!guideInfoObj) {
          // 获取导旅用户权限
          apig.getUser(type).then((res) => {
            if (res.ret === 0) {
              let guideInfo = res.data;
              localStorage.setItem('guideInfoObj', JSON.stringify(guideInfo));
              resolve(guideInfo);
            }
          });
        } else {
          resolve(JSON.parse(guideInfoObj));
        }
      });
    }
    case 'cityList': {
      // {regionCode: }
      return new Promise((resolve, reject) => {
        if (localStorage.citylList) {
          resolve(JSON.parse(localStorage.citylList));
        } else {
          api.region(params).then((res) => {
            let data = res.data;

            if (res.ret === 0) {
              let typeList = [];
              if (data && data.length === 1 && data[0].code === '530000') {
                // 省级
                let dataList = data[0].children;
                let arr = dataList.map(
                  ({ name, code, regionType, children }) => {
                    return {
                      text: name,
                      value: code,
                      regionType,
                      children: children
                        ? children.map(({ name, code, regionType }) => {
                            return {
                              text: name,
                              value1: code,
                              regionType
                            };
                          })
                        : []
                    };
                  }
                );
                let city = data.map(({ name, code, regionType }) => {
                  return {
                    text: name,
                    value: code,
                    regionType,
                    children: []
                  };
                });
                arr = city.concat(arr);
                for (var i = 0; i < arr.length; i++) {
                  if (arr[i].children) {
                    let cityChild = [
                      { text: '--', value1: '--', regionType: '' }
                    ];
                    let newArr = arr[i].children.concat([]);
                    arr[i].children = cityChild.concat(newArr);
                  }
                }
                typeList.push(arr);
                localStorage.citylList = JSON.stringify(typeList);
                resolve(typeList);
              } else if (data && data.length) {
                let brr = data.map(({ name, code, regionType, children }) => {
                  return {
                    text: name,
                    value: code,
                    regionType,
                    children: children
                      ? children.map(({ name, code, regionType }) => {
                          return {
                            text: name,
                            value1: code,
                            regionType
                          };
                        })
                      : []
                  };
                });
                for (var i = 0; i < brr.length; i++) {
                  if (brr[i].children) {
                    let cityChild = [
                      { text: '--', value1: '--', regionType: '' }
                    ];
                    let newArr = brr[i].children.concat([]);
                    brr[i].children = cityChild.concat(newArr);
                  }
                }
                typeList = [];
                typeList.push(brr);
                localStorage.citylList = JSON.stringify(typeList);
                resolve(typeList);
              }
            }
          });
        }
      });
    }
  }
};

export const getUrlQuery = (urlStr) => {
  let url;
  if (typeof urlStr == 'undefined') {
    url = decodeURI(location.search); //获取url中'?'符后的字符串
  } else {
    url = '?' + urlStr.split('?')[1];
  }
  let theRequest = {};
  if (url.indexOf('?') != -1) {
    let str = url.substr(1);
    let strs;
    strs = str.split('&');
    strs.forEach((item) => {
      const [key, value] = item.split('=');
      theRequest[key] = value;
    });
  }
  return theRequest;
};

export function getFilenameByUrl(url = '') {
  return url.split('/').pop();
}

export function getExtByName(name = '') {
  return name.split('.').pop()?.toLowerCase() || 'unknown';
}

export default {
  handleToComplaint,
  openWindow,
  handleToComplainList,
  handleToDoList,
  handleToComplainDetail,
  storageGetByName,
  getUrlQuery,
  getFilenameByUrl,
  getExtByName
};
